module.exports = __webpack_public_path__ + "static/media/night_sounds.95602bb3.mp3";